import { render, staticRenderFns } from "./CBoxDoughnutChart.vue?vue&type=template&id=5f7c468b&scoped=true&"
import script from "./CBoxDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./CBoxDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./CBoxDoughnutChart.vue?vue&type=style&index=0&id=5f7c468b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c468b",
  null
  
)

export default component.exports